export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  };

  export const deleteCookie = (name) => {
    // Set the cookie's expiration date to a past date to ensure it is removed
    const expires = new Date(0); // Setting the expiry to Unix epoch (Jan 1, 1970)
    document.cookie = `${name}=; expires=${expires.toUTCString()}; Max-Age=0; path=/; domain=${window.location.hostname}; secure; SameSite=Lax`;
  };

  export const deleteCookiesLoginUser = () => {
    deleteCookie("authToken");
    deleteCookie("username");
    deleteCookie("email");
    deleteCookie("userGuid");
    deleteCookie("User");
  }
  
  export function setCookie(name, value, options = { expires: 1 }) {
    // Check if we need to remove the cookie
    if (value === undefined) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${window.location.hostname}; path=/;`;
      return;
    }
    const expires = new Date();
    expires.setTime(expires.getTime() + options.expires * 24 * 60 * 60 * 1000);
    // Get the domain dynamically from the current URL
    const domain = window.location.hostname;
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; domain=${domain}; path=/;`;
}


export const handlePasswordValidation = (password) => {
    if (password && password.length >= 6) {
      return true;
    } else {
      return false;
    }
  };